import homeIcon from '@iconify/icons-ant-design/home-outline';
import { Icon } from '@iconify/react';
import { Donut } from '@/widgets/components/donut';
import React from 'react';
import { numberWithCommas } from '@/utils/string-utils';
import * as styles from './online-platforms-list-styles';

/**
 * List item specific for the OnlinePlatfomrsList this list item is specific to this component
 *
 * @param {string} props.label
 * @param {number} props.value
 * @param {number} props.percentage
 */
function PlatformListItem({ label, value, percentage }) {
  return (
    <styles.ItemWrapper>
      <Donut percentage={percentage} logoName={label.toLowerCase()} />
      <styles.Data>
        <styles.Label>{label}</styles.Label>
        <styles.Value>
          <styles.ValueNumberWrapper>
            {`${numberWithCommas(value)}`}
          </styles.ValueNumberWrapper>
          <styles.ValueIconWrapper>
            <Icon icon={homeIcon} width="12px" />
          </styles.ValueIconWrapper>
        </styles.Value>
      </styles.Data>
    </styles.ItemWrapper>
  );
}

export function OnlinePlatformsList({ data }) {
  return (
    <styles.Wrapper>
      {data.map((itemData) => (
        <PlatformListItem key={itemData.label} {...itemData} />
      ))}
    </styles.Wrapper>
  );
}
